module.exports = __webpack_public_path__ + "static/media/PathFinding.7e23639c.jpg";